module.exports = __webpack_public_path__ + "static/img/barlowcondensed-light-webfont.11c66f9.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/barlowcondensed-light-webfont.svg
// module id = 208
// module chunks = 0